var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgThumbsUp(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "thumbs-up"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.75 13.75L13.75 2.5C14.7446 2.5 15.6984 2.89509 16.4017 3.59835C17.1049 4.30161 17.5 5.25544 17.5 6.25V11.25H24.575C24.9374 11.2459 25.2963 11.3206 25.627 11.469C25.9576 11.6174 26.252 11.8359 26.4898 12.1094C26.7276 12.3829 26.9031 12.7048 27.0042 13.0528C27.1052 13.4009 27.1294 13.7667 27.075 14.125L25.35 25.375C25.2596 25.9711 24.9568 26.5145 24.4974 26.905C24.038 27.2955 23.4529 27.5068 22.85 27.5H8.75M8.75 13.75V27.5M8.75 13.75H5C4.33696 13.75 3.70107 14.0134 3.23223 14.4822C2.76339 14.9511 2.5 15.587 2.5 16.25V25C2.5 25.663 2.76339 26.2989 3.23223 26.7678C3.70107 27.2366 4.33696 27.5 5 27.5H8.75",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbsUp);
export default __webpack_public_path__ + "static/media/thumbs-up.acb6a15cd4875704808644b4a3cdbd92.svg";
export { ForwardRef as ReactComponent };